import React, { PropTypes } from 'react';
import ConfirmDialog from 'common/components/modal/confirmation_dialog';
import Money from 'common/components/money';

/**
 * Award entry button.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const AwardButton = ({ canAward, award, entry, toggleConfirmation }) => {
  if (!canAward || !award) {
    return null
  }

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleConfirmation(entry, award);
  }

  return (
    <div className="award-btn-wrapper">
      <button className="btn btn-primary" onClick={handleClick}>
        Award <Money value={award.feature.value}/>
      </button>
    </div>
  )
};

AwardButton.propTypes = {
  award: PropTypes.object,
  entry: PropTypes.object.isRequired,
  canAward: PropTypes.bool.isRequired,
  toggleConfirmation: PropTypes.func.isRequired
};

export default AwardButton;



// WEBPACK FOOTER //
// ./entries/components/award_button.jsx